export default function BigPrimaryButton({ title, onClick, disabled }) {
  return (
    <button
      disabled={disabled}
      className="bg-primary-button-dark-blue px-8 rounded-3xl py-3 border-4 border-yellow-400"
      onClick={onClick}
    >
      <span className="font-mali font-bold text-3xl text-white">{title}</span>
    </button>
  );
}
